import { Component, Mixins, Prop } from 'vue-property-decorator';
import ProjectContainerMixin from './ProjectContainerMixin';
import ProjectMobile from './ProjectMobile.vue';
import StudioModalMobile from '@/components/modals/StudioModalMobile.vue';
import StreamStatus from '@/components/editor/StreamStatus.vue';
import DraggableStreamContainer from '@/components/editor/DraggableStreamContainer.vue';
import CreateEditProjectModalMobile from './modals/CreateEditProjectModalMobile.vue';
import NewsUpdateButton from '@/components/topnav/NewsUpdateButton.vue';

@Component({
  components: {
    ProjectMobile,
    StudioModalMobile,
    StreamStatus,
    DraggableStreamContainer,
    CreateEditProjectModalMobile,
    NewsUpdateButton,
  },
})
export default class ProjectContainerMobile extends Mixins(ProjectContainerMixin) {
  async mounted() {
    if (!this.projects.length || !this.activeProject) this.loadProjects();
  }
}
